var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNoseshape = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9 42.406c.113-.095.227-.2.34-.308l-.298 1.71c-.1.569.251 1.138.815 1.266a1.084 1.084 0 0 0 1.303-.862l2.02-11.545.013-.1c.114-.563.223-1.15.327-1.752.759-4.389.99-8.274 1-8.436a1.077 1.077 0 1 0-2.151-.123c0 .038-.237 3.924-.972 8.194-.933 5.392-2.274 9.055-3.776 10.311-3.858 3.223-5.578 5.559-6.142 8.34-.673 3.342.73 5.73 1.749 6.957a1.083 1.083 0 0 0 1.668-1.379c-.725-.886-1.801-2.687-1.303-5.15.455-2.247 1.971-4.242 5.407-7.11v-.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.829 49.087c-.56-2.781-2.284-5.118-6.142-8.34-1.502-1.256-2.843-4.91-3.776-10.293-.74-4.27-.972-8.174-.977-8.212a1.08 1.08 0 0 0-1.137-1.014 1.08 1.08 0 0 0-1.014 1.137c.01.162.242 4.047 1 8.435.104.607.213 1.19.327 1.754 0 .033.005.066.014.1l2.019 11.543a1.077 1.077 0 0 0 1.246.877c.583-.105.971-.692.872-1.275l-.299-1.706c.11.109.223.213.342.308 3.44 2.872 4.956 4.867 5.407 7.108.497 2.464-.578 4.265-1.303 5.151a1.084 1.084 0 0 0-.01 1.36c.426.54 1.241.55 1.677.02 1.02-1.228 2.422-3.612 1.75-6.957l.004.004Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.215 55.47c-1.924 0-4.213 1.92-6.426 3.778l-.242.204c-1.71 1.43-3.374 1.46-3.445 1.46h-.004c-.072 0-1.735-.03-3.445-1.46l-.242-.204c-2.213-1.858-4.502-3.777-6.426-3.777-1.407 0-2.853.626-3.507 1.521-.36.493-.469 1.043-.308 1.554.394 1.247 1.957 3.138 7.995 1.773.042-.01.085-.024.123-.033.256.208.502.417.734.616l.242.203c2.256 1.891 4.554 1.962 4.82 1.962h.023c.27 0 2.564-.07 4.82-1.962l.241-.203c.237-.2.483-.403.735-.616.038.014.08.023.123.033 1.483.336 2.7.474 3.691.474 3.043 0 4.005-1.308 4.303-2.247.161-.511.052-1.066-.308-1.554-.654-.895-2.1-1.521-3.507-1.521h.01Z"
  }))));
};
export { SvgNoseshape as ReactComponent };